module.exports = __webpack_public_path__ + "fonts/7a9f5e8a-31f9-430c-bb19-1920ca99b73a.1be166e.eot";